import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ReadinessSummary } from "@/components/email/launch/ReadinessSummary";
import { CheckoutWordingPanel } from "@/components/email/launch/CheckoutWordingPanel";
import { MailcoachApiPanel } from "@/components/email/launch/MailcoachApiPanel";
import { AuthAuditPanel } from "@/components/email/launch/AuthAuditPanel";
import { HeaderCheckPanel } from "@/components/email/launch/HeaderCheckPanel";
import { E2ePanel } from "@/components/email/launch/E2ePanel";
import { PilotPanel } from "@/components/email/launch/PilotPanel";
import { ReconcilePanel } from "@/components/email/launch/ReconcilePanel";
import { DeliveryTestPanel } from "@/components/email/launch/DeliveryTestPanel";
import { ConsentReviewPanel } from "@/components/email/launch/ConsentReviewPanel";

export default function EmLaunchReadiness() {
  const { can } = useAuth();
  const admin = can("email_marketing.settings");
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(() => {
    api.get("/email-marketing/launch/readiness").then((r) => { setD(r.data); setErr(null); }).catch((e) => setErr(e?.response?.data?.detail || "Could not load launch readiness"));
  }, []);
  useEffect(() => { load(); }, [load]);
  if (err) return <p className="text-sm text-red-600" data-testid="launch-error">{err}</p>;
  if (!d) return <p className="text-sm text-slate-400" data-testid="launch-loading">Loading…</p>;
  return (
    <div className="space-y-5" data-testid="em-launch-page">
      <div><h2 className="text-lg font-bold text-slate-900">Launch readiness</h2>
        <p className="text-sm text-slate-500">Resuming your existing Mailcoach → SendGrid email marketing in TedOps. Live campaign sending stays locked until every check passes and you approve it.</p></div>
      <ReadinessSummary d={d} />
      {admin && <ReconcilePanel />}
      <DeliveryTestPanel admin={admin} ms={d.microsoft_delivery} onChange={load} />
      <ConsentReviewPanel />
      <CheckoutWordingPanel admin={admin} onChange={load} />
      <MailcoachApiPanel admin={admin} onChange={load} />
      <AuthAuditPanel admin={admin} last={d.auth_audit} onChange={load} />
      <HeaderCheckPanel admin={admin} last={d.microsoft_header_check} onChange={load} />
      <E2ePanel admin={admin} last={d.e2e} onChange={load} />
      <PilotPanel admin={admin} d={d} onChange={load} />
    </div>
  );
}
